import * as React from 'react';

import ContractorId56 from './ContractorId56';

export const contractorId56 = () => <ContractorId56 />;

export default {
    title: 'Illustration/ContractorId56',
    component: ContractorId56,
    parameters: {
        notes: "`import ContractorId56 from 'box-ui-elements/es/illustration/ContractorId56';`",
    },
};
